export default __webpack_public_path__ + "static/media/support-01.69ff1e9f.svg";